export const fidoDemoContextPath = ""; // No context path for fido demo app
export const webappPath = `${fidoDemoContextPath}/webapp`;
export const startPath = `${fidoDemoContextPath}/`;
export const successPath = `${fidoDemoContextPath}/success`;
export const loginPath = "/oauth2/authorization/oidc";
export const userInfoPath = "/api/user/info";
